import styled, { css } from 'styled-components';

const LoaderSpinner = styled.div((props) => css`
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.4em solid ${props.theme.colors.bgDarker};
  border-right: 0.4em solid  ${props.theme.colors.bgDarker};
  border-bottom: 0.4em solid  ${props.theme.colors.bgDarker};
  border-left: 0.4em solid ${props.theme.colors.bgInverse};
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
  border-radius: 50%;
  width: ${props.width || '20px'};
  height: ${props.height || '20px'};
  &:after {
    border-radius: 50%;
    width: ${props.width || '20px'};
    height: ${props.height || '20px'};
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`);


export default LoaderSpinner;
